<template>
  <div style="width:100%;float:left;">
    <!-- <CRow>
      <CCol sm="12">
        <search-orders></search-orders>
      </CCol>
    </CRow> -->
    <CCard>
      <CCardHeader>Admin Assistant Table</CCardHeader>
      <CCardBody style="min-height:300px;">
        <div class="col-12 text-left float-left">
          <label style="width:100%;float:left;text-align:center;">Don't see it in table? Search all database with this search field. (When there is something in the search field, it will ignore the status filter)</label>
          <!-- <input type="text" class="form-control" @keyup.esc="search = ''" style="width:250px;" placeholder="Search..." v-model="search" /> -->
          <div style="width:320px;text-align:center;margin-left:auto;margin-right:auto;">
            <h5>Search by PO, CC, Log, Cust</h5>
            <input type="search" placeholder="Search..." class="form-control float-left searchInput" @keyup.enter="getGroups()" style="width:250px;" v-model="search" />
            <CButton size="sm" color="info" class="searchButton" @click="getGroups()">Search</CButton>
          </div>
        </div>
        <spacer />
        <div class="col-12 text-center mb-2 float-left">
          <select class="form-control" v-model="filter" style="width:250px;margin-left:auto;margin-right:auto;" @change="getGroups()">
            <option value="all">All</option>
            <option value="needs_sent">Needs Sent</option>
            <!-- <option value="blank_stock">Blank Stock</option> -->
            <option value="hub">Hub</option>
            <option value="released">Released</option>
            <option value="sent_to_csr">Sent to CSR</option>
            <option value="sent_to_aws">Sent to AWS</option>
            <option value="order_components">Order Components</option>
          </select>
        </div>
        <div class="col-12 text-center mb-2 float-left" v-if="filter === 'all'">
          <select class="form-control" v-model="daysAgo" style="width:250px;margin-left:auto;margin-right:auto;" @change="getGroups()">
            <option value="15 Days">15 Days</option>
            <option value="30 Days">30 Days</option>
            <!-- <option value="blank_stock">Blank Stock</option> -->
            <option value="60 Days">30-60 Days</option>
          </select>
        </div>
        <div class="col-12 text-left float-left">
          <!-- <input type="text" class="form-control" @keyup.esc="search = ''" style="width:250px;" placeholder="Search..." v-model="search" /> -->

          <CButton
            color="primary"
            class="mb-2 float-right"
            :href="csvCode" 
            download="Assistant_Dashboard.csv"
            target="_blank"
          >
            Download current Table
          </CButton>
        </div>

        <div class="col-12 text-center float-left" v-if="filter !== 'hub' && filter !== 'order_components'">

          <CDataTable
              :items="items"
              :fields="fields"
              pagination
              column-filter
              sorter
              table-filter
              v-if="items && !loading"
            >
              <template #check-header>
                  <input type="checkbox" :checked="checkAll()" @click="selectAll()" />
              </template>
              <template #order_id-header>
                  Order#
              </template>
              <template #as400_log_number-header>
                  Log#
              </template>
              <template #order_items="{item}">
                <td>
                  {{ item.order_items.length }}
                </td>
              </template>
              <template #c="{item}">
                <td>
                  <div v-if="item.color_coding" style="width:20px;height:20px;" :style="'background-color:' + item.color_coding + ';'"></div>
                </td>
              </template>
              <template #rep="{item}">
                <td>
                  {{item.rep ? item.rep : ''}}
                </td>
              </template>
              <template #po_number="{item}">
                <td>
                  {{item.po_number}}
                </td>
              </template>
              <template #assistant_status="{item, index}">
                <td>
                  <select v-if="changeCsrIndex === index" class="form-control" v-model="item.assistant_status" @change="statusChanged(item, index)">
                    <option value="NULL">Select Status</option>
                    <!-- <option value="blank_stock">Blank Stock</option> -->
                    <option value="hub">Send to Hub</option>
                    <option value="sent_to_csr">Sent to CSR</option>
                    <option value="sent_to_aws">Sent to AWS</option>
                    <option value="order_components">Order Components</option>
                  </select>
                  <div v-else-if="item.assistant_status === 'sent_to_csr'" style="cursor: pointer;" @click="changeCsr(index)">
                    {{item.csr_assigned ? 'Sent To ' + item.csr_assigned.name.split(' ')[0] : 'Sent To CSR'}}
                  </div>
                  <div v-else-if="item.assistant_status === 'blank_stock'">
                    <CButton size="sm" color="warning" @click="release(val)">Release</CButton>
                  </div>
                  <div v-else-if="item.assistant_status === 'released'">
                    <!-- <CButton size="sm" color="warning" @click="release(val)">Release</CButton> -->
                    Released
                  </div>
                  <select v-else class="form-control" v-model="item.assistant_status" @change="statusChanged(item, index)">
                    <option value="NULL">Select Status</option>
                    <!-- <option value="blank_stock">Blank Stock</option> -->
                    <option value="hub">Send to Hub</option>
                    <option value="sent_to_csr">Sent to CSR</option>
                    <option value="sent_to_aws">Sent to AWS</option>
                    <option value="order_components">Order Components</option>
                  </select>
                  <v-select v-if="csrs && item.assistant_status === 'sent_to_csr' && !item.csr_assigned" v-model="item.csr_assigned" @input="csrChanged(item, index)" label="name" value="id" :options="csrs"></v-select>
                </td>
              </template>
              <template #actions="{item, index}">
                <td :style="selectedIndex === index ? 'background-color:#c7c7c7;' : ''">
                  <CButton size="sm" color="info" @click="viewPdf(item, index)"><CIcon name="cil-fullscreen" /></CButton>
                  <CButton size="sm" class="ml-1" color="success" @click="goTo(item, index)"><CIcon name="cil-arrow-right" /></CButton>
                </td>
              </template>
            </CDataTable>

          <!-- <table class="table" v-if="items && !loading">
            <thead>
              <tr>
                <th>C</th>
                <th>Order#</th>
                <th>Log#</th>
                <th>CC#</th>
                <th>Rep</th>
                <th>PO</th>
                <th>Date</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(val, index) in items" v-show="configureShow(val)" :style="configureStyle(val, index)">
                <td>
                  <div v-if="val.color_coding" style="width:20px;height:20px;" :style="'background-color:' + val.color_coding + ';'"></div>
                </td>
                <td>{{val.order_id}}</td>
                <td>{{val.as400_log_number}}</td>
                <td>{{val.cc_number}}</td>
                <td>{{val.order.rep ? val.order.rep.name : ''}}</td>
                <td>{{val.order.po_number}}</td>
                <td>
                  {{val.local_created_at}}
                </td>
                <td>
                  <div v-if="val.assistant_status === 'sent_to_csr'">
                    {{val.csr_assigned ? 'Sent To ' + val.csr_assigned.name.split(' ')[0] : 'Sent To CSR'}}
                  </div>
                  <div v-else-if="val.assistant_status === 'blank_stock'">
                    <CButton size="sm" color="warning" @click="release(val)">Release</CButton>
                  </div>
                  <div v-else-if="val.assistant_status === 'released'">
                    Released
                  </div>
                  <select v-else class="form-control" v-model="val.assistant_status" @change="statusChanged(val, index)">
                    <option value="NULL">Select Status</option>
                    <option value="hub">Send to Hub</option>
                    <option value="sent_to_csr">Sent to CSR</option>
                    <option value="sent_to_aws">Sent to AWS</option>
                  </select>
                  <v-select v-if="csrs && val.assistant_status === 'sent_to_csr' && !val.csr_assigned" v-model="val.csr_assigned" @input="csrChanged(val, index)" label="name" value="id" :options="csrs"></v-select>
                </td>
                <td>
                  <CButton size="sm" color="info" @click="viewPdf(val, index)">View PDF</CButton>
                  <CButton size="sm" color="success" @click="goTo(val)">Go To</CButton>
                </td>
              </tr>
            </tbody>
          </table> -->
          <small-loader v-if="loading"></small-loader>
          <!-- <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            table-filter
            style="overflow-x:visible !important;"
            class="testingClass"
          >
            <template #rep_name="{item}">
              <td>
                {{item.order.rep.name}}
              </td>
            </template>
            <template #po_number="{item}">
              <td>
                {{item.order.po_number}}
              </td>
            </template>
            <template #pdf="{item}">
              <td>
                <CButton size="sm" color="info" @click="viewPdf(item)">View PDF</CButton>
              </td>
            </template>
            <template #go="{item}">
              <td>
                <CButton size="sm" color="success" @click="goTo(item)">Go To</CButton>
              </td>
            </template>
            <template #actions="{item}">
              <td>
                <select class="form-control" v-model="item.assistant_status" @change="statusChanged(item)">
                  <option value="null">Select Status</option>
                  <option value="hub">Send to Hub</option>
                  <option value="sent_to_csr">Sent to CSR</option>
                  <option value="sent_to_aws">Sent to AWS</option>
                </select>
              </td>
            </template>
          </CDataTable> -->
        </div>
        <div class="col-12 text-center float-left" v-else>
          <table class="table" v-if="items && !loading">
            <thead>
              <tr>
                <th>Order#</th>
                <th>Log#</th>
                <th>CC#</th>
                <th>Rep</th>
                <th>PO</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(val, index) in items" v-show="configureShow(val)" :style="configureStyle(val, index)">
                <td>{{val.order_id}}</td>
                <td>{{val.as400_log_number}}</td>
                <td>{{val.cc_number}}</td>
                <td>{{val.rep}}</td>
                <td>{{val.po_number}}</td>
                <td>
                  <CButton size="sm" color="info" @click="viewPdf(val, index)">View PDF</CButton>
                </td>
                <td>
                  <div style="min-width:200px;">
                    <v-select v-if="csrs" v-model="val.csr_assigned" @input="csrChanged(val)" label="name" value="id" :options="csrs"></v-select>
                  </div>
                </td>
                <td>
                  <CButton size="sm" color="success" @click="goTo(val)">Go To</CButton>
                </td>
              </tr>
            </tbody>
          </table>
          <small-loader v-if="loading"></small-loader>
          <!-- <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            table-filter
          >
            <template #rep_name="{item}">
              <td>
                {{item.order.rep.name}}
              </td>
            </template>
            <template #po_number="{item}">
              <td>
                {{item.order.po_number}}
              </td>
            </template>
            <template #pdf="{item}">
              <td>
                <CButton size="sm" color="info" @click="viewPdf(item)">PDF</CButton>
              </td>
            </template>
            <template #go="{item}">
              <td>
                <CButton size="sm" color="success" @click="goTo(item)">Go To</CButton>
              </td>
            </template>
            <template #actions="{item}">
              <td>
                <div style="min-width:200px;">
                  <v-select v-if="csrs" v-model="item.csr_assigned" @change="csrChanged(item)" label="name" value="id" :options="csrs"></v-select>
                </div>
              </td>
            </template>
          </CDataTable> -->
        </div>
      </CCardBody>
    </CCard>

    <CModal
      title="Escape Request"
      :show.sync="escapeModal"
      size="lg"
      >
      <div style="width:100%;float:left;">
        <div style="width:100%;float:left;text-align:center;">
          <CButton :color="requestType === 'escape' ? 'success' : 'outline-success'" @click="requestType = 'escape'">Escape</CButton>
          <CButton :color="requestType === 'order_entry' ? 'success' : 'outline-success'" @click="requestType = 'order_entry'">OE</CButton>
        </div>
        <div v-if="requestType === 'order_entry'" style="width:100%;float:left;">
          <order-entry-request @submitted="submitChange" v-if="escapeData" :group="escapeData" :newData="escapeData"></order-entry-request>
        </div>
        <div v-if="requestType === 'escape'" style="width:100%;float:left;">
          <escape-request @submitted="submitChange" v-if="escapeData" :group="escapeData" :newData="escapeData"></escape-request>
        </div>
      </div>
      <template #footer>
        <div style="width:100%;height:10px;float:left;"></div>
      </template>
    </CModal>

    <adobe-pdf-viewer v-if="pdfModal && pdfData" @closed="pdfModal = false, pdfData = null" :order_group="pdfData" pdf_type="either" :allowEdit="true"></adobe-pdf-viewer>

    <!-- <CModal
      title="PDF View"
      :show.sync="pdfModal"
      size="lg"
      >
      <div style="width:100%;float:left;" v-if="pdfData">
        <pdf-view :form="pdfData"></pdf-view>
      </div>
      <template #footer>
        <div style="width:100%;height:10px;float:left;"></div>
      </template>
    </CModal> -->
  </div>
</template>
<script>
// import PdfView from './pdf_view'
import AdobePdfViewer from './adobe_pdf_viewer'
import EscapeRequest from './../flow/escape_request'
import OrderEntryRequest from './../flow/order_entry_request'
var methods = {}

methods.goTo = function (item) {
  // console.log(item)
  this.$router.push('/order/' + item.order_id)
}

methods.changeCsr = function (index) {
  console.log(index)
  this.changeCsrIndex = index
}

methods.release = function (item, index) {
  item.assistant_status = 'released'
  this.selectedIndex = index
  this.statusChanged(item)
}

methods.configureStyle = function (item, index) {
  if (this.selectedIndex === '') {
    if (parseInt(item.fast_lane || 0) === 1) {
      return 'fastLane'
    } else if (item.customer_exception) {
      return 'customerException'
    } else if (item.event_date) {
      return 'eventRow'
    } else if (!item.cc_number && !item.cc_email_sent) {
      // return 'background-color:#ffcccc;'
      return 'noCCTable';
    }
  } else {
    if (parseInt(this.selectedIndex) === parseInt(index)) {
      // return 'background-color: #c7c7c7;'
      return ''
    }
  }
}

methods.configureShow = function (val) {
  var that = this
  if (!this.search) {
    return true
  } else {
    var result = false
    this.fields.forEach(function (field) {
      console.log(val[field])
      if (val[field]) {
        if (val[field].toString().toLowerCase().includes(that.search.toLowerCase())) {
          result = true
        }
      }
    })
  }
  return result
}

methods.getGroups = function () {
  this.loading = true
  window.localStorage.setItem('assistant_filter', this.filter)
  const postData = {
    filter: this.filter,
    daysAgo: this.daysAgo,
    search: this.search,
  }

  axios.post(this.$apiAdress + '/api/orders/getOrderGroupsByAssistant?token=' + localStorage.getItem('api_token'), postData).then(response => {
    // this.items = response.data
    var i = 0
    var arr = []
    var that = this
    response.data.forEach(function (val) {
      var o = {}
      for (var key in val) {
        o[key] = val[key]
      }
      o._classes = that.configureStyle(val, i)
      arr.push(o)
      i++
    })
    this.items = arr
    console.log(response)
    this.loading = false
  })
}

methods.csrChanged = function (item, index) {
  console.log(item)
  item.assistant_status = 'sent_to_csr'
  const postData = {
    item: item
  }
  axios.post(this.$apiAdress + '/api/orders/assistantStatusChanged?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.selectedIndex = index
    this.changeCsrIndex = ''
  })
}

methods.viewPdf = function (item, index) {
  // var obj = {
  //   form: item.order
  // }
  // obj.form.cc_number = item.cc_number
  // obj.form.log_number = item.log_number
  // obj.form.ship_date = item.ship_date
  // obj.form.event_date = item.event_date
  // obj.form.ship_via = item.ship_via
  // obj.form.prebook = item.prebook
  // obj.form.as400_log_number = item.as400_log_number
  // obj.form.order_items = item.order_items
  this.pdfModal = true
  this.selectedIndex = index
  // this.pdfData = obj.form
  this.pdfData = item
  this.$forceUpdate()
  // this.pdfGroup = item
}

methods.submitChange = function (form) {
  console.log(form)
  const postData = {
    item: this.escapeData,
    form: form
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/orders/assistantStatusChanged?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.escapeData = null
    this.escapeModal = false
  })
}

methods.statusChanged = function (item) {
  console.log(item)
  if (item.assistant_status !== 'sent_to_aws' && item.assistant_status !== 'sent_to_csr') {
    const postData = {
      item: item
    }
    axios.post(this.$apiAdress + '/api/orders/assistantStatusChanged?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
    })
  } else if (item.assistant_status === 'sent_to_aws') {
    this.escapeData = item
    this.escapeModal = true
  }
}

methods.getCsrs = function () {
  axios.get(this.$apiAdress + '/api/getAllCsrs?token=' + localStorage.getItem('api_token')).then(response => {
    this.csrs = response.data
  })
}

export default {
  // ===Component name
  name: "AdminAssistantDashboard",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {
    EscapeRequest,
    // PdfView,
    OrderEntryRequest,
    AdobePdfViewer
  },
  // ====component Data properties
  data(){
      return{
        items: null,
        fields: [
          'c',
          'order_id',
          'as400_log_number',
          'cc_number',
          'rep',
          'po_number',
          'local_created_at',
          'assistant_status',
          'actions'
        ],
        changeCsrIndex: '',
        filter: 'needs_sent',
        escapeData: null,
        escapeModal: false,
        pdfModal: false,
        pdfData: null,
        csrs: null,
        loading: false,
        selectedIndex: '',
        search: '',
        requestType: '',
        daysAgo: '15 Days',
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getCsrs()
    if (window.localStorage.getItem('assistant_filter')) {
      this.filter = window.localStorage.getItem('assistant_filter')
      this.getGroups()
    } else {
      this.getGroups()
    }
  },
  watch: {
    'search': function (newVal, oldVal) {
      if (!newVal) {
        this.getGroups()
      }
    }
  },
  // ===Computed properties for the component
  computed: {
    csvContent () {
      if (this.items) {
        var content = this.items
        var headers = []
        for (var key in this.items[0]) {
          headers.push('' + key)
        }
        var arr = []
        arr.push(headers)
        this.items.forEach(function (val) {
          arr.push(val)
        })
        // arr.pop(headers)
        // arr.unshift(headers)
        return arr.map(item => Object.values(item).join(',')).join('\n')
      } else {
        return ''
      }
    },
    csvCode () {
      return 'data:text/csv;charset=utf-8,' + encodeURIComponent(this.csvContent)
    }
  },
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped>
.fastLane {
  background-color: #06c743;
  color: black;
}
</style>
